<script setup>

import { ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import VisualizarPedidoDeCompra from "./VisualizarPedidoDeCompra/VisualizarPedidoDeCompraModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

import { runAction } from "../../services/actionService.js";

import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;



//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const controlesDesativados = ref(false);
const reprovandoPedidos = ref(false);
const aprovandoPedidos = ref(false);
const visualizandoPedido = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidosDeCompraSelecionados = ref([]);
const pedidoDeCompraLoading = ref(true);
const pedidoDeCompraVisualizar = ref({});

//==================================================================//
//======================== Campos de Busca =========================//
//==================================================================//

const buscaGeral = ref("");

//==================================================================//
//==================== Pedidos de Compra Header ====================//
//==================================================================//

let pedidoDeCompraHeaders = [
    { text: '',                                         value: 'visualizar',                  class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: '',                                         value: 'pdf',                         class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'N° do Pedido',                             value: 'codigo',                      class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Fornecedor',                               value: 'fornecedor.nome',             class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Vendedor(a)',                              value: 'fornecedorVendedor.nome',     class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total dos itens',                          value: 'precoTotal',                  class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total Geral (Impostos Inclusos)',          value: 'precoTotalComImpostosComIPI', class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total dos Itens (Sem Impostos + IPI)',     value: 'precoTotalSemImpostosComIPI', class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total do Disponivel',                      value: 'valorDisponivel',             class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Data de Criação',                          value: 'dataCriacao',                 class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Itens',                                    value: 'itens',                       class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Parcelas',                                 value: 'parcelas',                    class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    // { text: 'Coordenadores',                            value: 'aprovadores',               class:"c-pedido__header",    cellClass:'c-pedido__cell'},
]

//==================================================================//
//===================== Load Pedidos de Compra  ====================//
//==================================================================//

const loadPedidosDeCompra = async () =>{

    pedidoDeCompraLoading.value = true;

    pedidosDeCompraSelecionados.value = [];

    const pedidosDeCompraResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_APROVACAO_COMPRADOR,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore.usuario.id
        },
        {
            name: "colaborador",
            dataType: "String",
            value: colaboradorStore.colaborador.id
        },
    ]);

    pedidosDeCompra.value = pedidosDeCompraResponse.data;

    clearBuscaGeral();

    pedidoDeCompraLoading.value = false;

};

//==================================================================//
//======================== Fill Buscadores =========================//
//==================================================================//

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};

//==================================================================//
//=========================== Clamp Valor ==========================//
//==================================================================//

const clampValor = (valor,min,max) =>{

    return Math.min(Math.max(valor, min), max);

};

//==================================================================//
//=================== Valor Monetario Formatado ====================//
//==================================================================//

const valorMonetarioFormatado = (valor = 0)=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(clampValor(valor,-999999999,999999999));

};

//==================================================================//
//================ Obtem Contador de Coordenadores =================//
//==================================================================//

// const obtemContadorDeCoordenadores = (aprovadores = [])=>{

//     let contador = aprovadores.reduce((acc,aprovador)=>{

//         if(aprovador.tipo != "Coordenador"){
//             return acc;
//         }

//         acc.coordenadores++;

//         if(aprovador.decisao != ""){
//             acc.decidiram++;
//         }

//         return acc;

//     },{decidiram:0, coordenadores:0});

//     return `${contador?.decidiram}/${contador?.coordenadores}`;

// };

//==================================================================//
//====================== Ao Reprovar Pedidos =======================//
//==================================================================//

const aoReprovarPedidos = async ()=>{

    if(UtilArray.isEmpty(pedidosDeCompraSelecionados.value)){
        return false;
    }

    reprovandoPedidos.value = true;

}

//==================================================================//
//============== Ao Decidir Reprovar Pedidos de Compra =============//
//==================================================================//

const aoDecidirReprovarPedidos = async ()=>{

    reprovandoPedidos.value = false;
    await loadPedidosDeCompra();

}

//==================================================================//
//================== Ao Aprovar Pedido de Compra ===================//
//==================================================================//

const aoAprovarPedidos = async ()=>{

    if(UtilArray.isEmpty(pedidosDeCompraSelecionados.value)){
        return false;
    }

    aprovandoPedidos.value = true;

}

//==================================================================//
//============== Ao Decidir Aprovar Pedido de Compra ===============//
//==================================================================//

// const aoDecidirAprovarPedidos = async ()=>{

//     aprovandoPedidos.value = false;
//     await loadPedidosDeCompra();

// }

//==================================================================//
//================ Altera Visualizacao do Pedido ===================//
//==================================================================//

const alteraVisualizandoPedido = (update)=>{

    visualizandoPedido.value = update.visualizandoPedido;
    pedidoDeCompraVisualizar.value = update?.pedidoDeCompra || {};

    if(visualizandoPedido.value == false){
        loadPedidosDeCompra();
    }


};

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update.controlesDesativados;

};

//==================================================================//
//================ Ao Visualizar Pedido de Compra ==================//
//==================================================================//

const aoVisualizarPedidoDeCompra = (item)=>{

    alteraVisualizandoPedido({
        visualizandoPedido: true,
        pedidoDeCompra: item
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

   await loadPedidosDeCompra();

});

//==================================================================//
//==================== Watch Controle Desativado ===================//
//==================================================================//

watch(reprovandoPedidos, (novoValor) => {

    alteraControlesDesativados({
        controlesDesativados: novoValor
    });

});

watch(aprovandoPedidos, (novoValor) => {

    alteraControlesDesativados({
        controlesDesativados: novoValor
    });

});


//==================================================================//
//===================== Download PDF do Pedido =====================//
//==================================================================//

const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = () => {
        const base64data = reader.result;   
        resolve(base64data);
        //console.log('base64data: ', base64data)
        }
    });
};

const downloadPDFDoPedido = async (id) =>{

    let pdfResponse = await runAction({name:"PDF Pedido de Compra"},{
        id: id,
    });

    console.log(id);

    if(pdfResponse?.data?.content[0]?.image){
        const url = pdfResponse?.data?.content[0]?.image;
        const url64 = await getBase64FromUrl(url?.toString())
        pdfResponse.data.content[0].image = url64
    }

    if(pdfResponse.footer){
        let columns = pdfResponse.footer;
        console.log("COLUMNS >>> ", columns)

        pdfResponse.data.footer = function(currentPage, pageCount) { //currentPage, pageCount
            // this.result.currentPage = currentPage
            // this.result.pageCount = pageCount

            return JSON.parse(JSON.stringify(columns));

        }
    }

    if(pdfResponse.header){
        pdfResponse.data.header = pdfResponse.header;
    }

    console.log(pdfResponse);

    let teste = pdfMake.createPdf(pdfResponse.data).download("PDF Pedido de Compra");

    console.log(teste);

};

</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Aprovação do Comprador
        </h2>

        <v-card>

            <v-card-title
                class="c-pedido-holder"
            >

                <h3
                    class="c-pedido__titulo"
                >
                    Pedidos de Compra
                </h3>

                <div
                    class="c-pedido__buscas"
                >

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <v-chip
                    class="c-comprador"
                    label
                >

                    <v-icon left>
                        mdi-account-circle-outline
                    </v-icon>
                    Comprador:
                    {{colaboradorStore.colaborador.nome}}

                </v-chip>

                <div
                    class="c-pedido__controles"
                >
                
                    

                    <div
                        class="c-controles__botao-esquerda"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-on:click="aoReprovarPedidos"
                                    :disabled="controlesDesativados"
                                    :loading="reprovandoPedidos"
                                >
                                    Reprovar
                                
                                </v-btn>

                            </template>

                            <span>Retorna os Pedidos de Compra para os Compradores</span>

                        </v-tooltip>

                    </div>

                    <div
                        class="c-controles__botao-direita"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="aoAprovarPedidos"
                                    :disabled="controlesDesativados"
                                    :loading="aprovandoPedidos"
                                >

                                    Aprovar
                                    
                                </v-btn>

                            </template>

                            <span>Aprova os Pedidos de Compra e os envia para os Diretores</span>

                        </v-tooltip>

                    </div>

                </div>

            </v-card-title>

            <!-- show-select -->
            <v-data-table
                class="c-pedido__tabela elevation-1"
                v-model="pedidosDeCompraSelecionados"
                :headers="pedidoDeCompraHeaders"
                :items="pedidosDeCompra"
                :search="buscaGeral"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                return-object
                :loading="pedidoDeCompraLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.visualizar="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-visualizar-pedido mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="aoVisualizarPedidoDeCompra(item)"
                            >

                                <v-icon dark>
                                    mdi-eye
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Visualizar o Pedido de Compra</span>

                    </v-tooltip>

                </template>

                <template v-slot:item.pdf="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-visualizar-pedido mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="downloadPDFDoPedido(item.id)"
                            >

                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Download PDF Pedido de Compra</span>

                    </v-tooltip>

                </template>

                <template v-slot:item.precoTotal="{ item }">

                    R$ {{valorMonetarioFormatado(item?.precoTotal)}}

                </template>

                <template v-slot:item.precoTotalComImpostosComIPI="{ item }">

                    R$ {{valorMonetarioFormatado(item?.precoTotalComImpostosComIPI)}}

                </template>

                <template v-slot:item.precoTotalSemImpostosComIPI="{ item }">

                    R$ {{valorMonetarioFormatado(item?.precoTotalSemImpostosComIPI)}}

                </template>

                <template v-slot:item.valorDisponivel="{ item }">

                    R$ {{valorMonetarioFormatado(item?.valorDisponivel)}}

                </template>

                <template v-slot:item.itens="{ item }">

                    <v-chip
                        color="primary"
                        label
                    >

                        <v-icon left>
                            mdi-cube-outline
                        </v-icon>
                        {{item.itens.length}}

                    </v-chip>
                    
                </template>

                <template v-slot:item.parcelas="{ item }">

                    <v-chip
                        color="deep-orange"
                        label
                        dark
                    >

                        <v-icon left>
                            mdi-cash-multiple
                        </v-icon>
                        {{item.parcelas.length}}

                    </v-chip>

                </template>

                <!-- <template v-slot:item.aprovadores="{ item }">

                    <v-chip
                        color="teal"
                        label
                        dark
                    >

                        <v-icon left>
                            mdi-account-circle-outline
                        </v-icon>
                        
                        {{obtemContadorDeCoordenadores(item.aprovadores)}}

                    </v-chip>

                </template> -->
        
            </v-data-table>

        </v-card>

        <VisualizarPedidoDeCompra
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompraVisualizar"
            :controlesDesativados="controlesDesativados"
            :visualizandoPedido="visualizandoPedido"
            @update:visualizandoPedido="alteraVisualizandoPedido"
            @update:controlesDesativados="alteraControlesDesativados"
        ></VisualizarPedidoDeCompra>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-pedido__header{
    pointer-events: none;
    user-select: none; 
}

.c-pedido-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto auto; 
    grid-template-areas: 
    "titulo ."
    "buscas comprador"
    ". controles";
    gap: 10px;
}

.c-pedido__title { 
    grid-area: titulo;
}

.c-pedido__buscas { 
    grid-area: buscas;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-comprador{
    grid-area: comprador;
    margin: 0 20px;
    min-height: 48px;
}

.c-comprador >>> .v-chip__content{
    margin: auto;
}

.c-pedido__controles {
    grid-area: controles;
    display: grid;
    grid-template-areas: 
    "botao-esquerda botao-direita";
    padding: 0 20px;
    gap: 10px;

    display: none; 
    /*Futuramente será desenvolvido*/
}

.c-controles__botao-esquerda { 
    grid-area: botao-esquerda;
    display: grid;
    grid-auto-flow: column;
}

.c-controles__botao-direita { 
    grid-area: botao-direita;
    display: grid;
    grid-auto-flow: column;
}

.c-pedido__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-pedido{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

@media (width <= 850px) {
    
    .c-pedido-holder{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "comprador"
            "controles"
            "buscas";
    }

    .c-comprador{
        margin: 0;
    }

    .c-pedido__controles{
        padding: 0;
    }

    .c-pedido__buscas { 
        grid-template-rows: 1fr; 
        grid-template-areas: 
            "buscaGeral";
    }

}

</style>